import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from '../services/session.service';
import { ImperialDistanceUnit, MeasurementSystem } from '../models/measurementSystem';
import { MeasurementUnit } from '../models/measurementUnit';

export const IMPERIAL_UNIT_SHORT_LABELS: Map<ImperialDistanceUnit, string> = new Map([
	['inches', 'COMMON.FULL_METRICS.INCHES'],
	['feet', 'COMMON.METRICS.FEET']
]);

export const IMPERIAL_UNIT_FULL_LABELS: Map<ImperialDistanceUnit, string> = new Map([
	['inches', 'COMMON.METRICS.INCHES'],
	['feet', 'COMMON.FULL_METRICS.FEET']
]);

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'measurementUnitTranslate',
    standalone: true
})
export class MeasurementUnitTranslatePipe implements PipeTransform {

	constructor(private translate: TranslateService, private sessionService: SessionService) {}

	private getDistanceLabel(shortWord: boolean = true, imperialUnit: ImperialDistanceUnit = 'inches'): string {
		let unitKey: string = '';

		switch (this.sessionService.defaults.measurement_system) {
			case MeasurementSystem.Imperial: {
				unitKey = shortWord
					? IMPERIAL_UNIT_SHORT_LABELS.get(imperialUnit) || ''
					: IMPERIAL_UNIT_FULL_LABELS.get(imperialUnit) || '';
				break;
			}
			case MeasurementSystem.Metrics: {
				unitKey = shortWord
					? 'COMMON.METRICS.METERS'
					: 'COMMON.FULL_METRICS.METERS';
				break;
			}
			default: {
				unitKey = '';
			}
		}

		if (!unitKey) return unitKey;

		let result: string = '';
		this.translate.get(unitKey).subscribe({
			next: (translate: string) => (result = translate),
			error: () => (result = unitKey),
		});

		return result;
	}

	private getMassLabel(shortWord: boolean = true): string {
		let unitKey: string = '';

		switch (this.sessionService.defaults.measurement_system) {
			case MeasurementSystem.Imperial: {
				unitKey = shortWord
					? 'COMMON.METRICS.POUNDS'
					: 'COMMON.FULL_METRICS.POUNDS';
				break;
			}
			case MeasurementSystem.Metrics: {
				unitKey = shortWord
					? 'COMMON.METRICS.KILOGRAMS'
					: 'COMMON.METRICS.KILOGRAMS';
				break;
			}
			default: {
				unitKey = '';
			}
		}

		if (!unitKey) return unitKey;

		let result: string = '';
		this.translate.get(unitKey).subscribe({
			next: (translate: string) => (result = translate),
			error: () => (result = unitKey),
		});

		return result;
	}

	transform(
		unit: MeasurementUnit,
		shortWord: boolean = true,
		imperialDistanceUnit: ImperialDistanceUnit = 'inches'
	): string {
		switch (unit) {
			case 'distance': return this.getDistanceLabel(shortWord, imperialDistanceUnit ?? 'inches');
			case 'mass': return this.getMassLabel(shortWord);
			default: return '';
		}
	}
}
